import React, { useContext, useEffect } from 'react';
import { PortalNavContext } from '../PortalNavContext/PortalNavContext';
import { Container } from '../../components/layout/WrapperDiv';
import { PatientPortalTable } from './PatientPortalTable';
import { LISTING, PATIENT } from '../PortalNavContext/constants';
import { PatientPortalContext } from '../../context';
import { usePortalNav } from './usePortalNav';

export const PatientPortalComponent = () => {
  const { patientsList } = useContext(PatientPortalContext);
  const { page, patientNumber, loading } = useContext(PortalNavContext);
  const { openPatient } = usePortalNav();
  const loadingClass = loading ? `${page}-loading` : '';

  const { smartchartUrl } = window.env.hosts as any;

  // route on load
  useEffect(() => {
    if (patientsList.length === 1) {
      openPatient(patientsList[0].patientNumber);
    }
  }, []);

  return (
    <Container id="patient-portal-container">
      {/* when loading, table always has an animation */}
      {(loading || page === LISTING) && (
        <PatientPortalTable loadingClass={loadingClass} />
      )}
      {page === PATIENT && (
        <iframe
          src={`${smartchartUrl}/${patientNumber}?patientheader=true`}
          title={`patient-${patientNumber}-dashboard`}
          style={{ height: '100%', width: '100%', border: '1px solid' }}
        />
      )}
    </Container>
  );
};

export default PatientPortalComponent;
